import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSession } from "./lib/useSession";
import { isSupabaseConfigured } from "./lib/supabase";
import { subscribeLang } from "./lib/i18n";
import { AuthScreen } from "./screens/AuthScreen";
import { Dashboard } from "./screens/Dashboard";
import { ConfigMissingScreen } from "./screens/ConfigMissingScreen";
import { LegalScreen } from "./screens/LegalScreen";
import { CookieConsent } from "./components/CookieConsent";
import { ThemeSwitcher } from "./components/ThemeSwitcher";
import { LanguageSwitcher } from "./components/LanguageSwitcher";
import { EventRsvpScreen } from "./screens/EventRsvpScreen";
import { PublicBookingScreen } from "./screens/PublicBookingScreen";
import { ProfileViewScreen } from "./screens/ProfileViewScreen";
import { PricingScreen } from "./screens/PricingScreen";
import { BusinessProfileScreen } from "./screens/BusinessProfileScreen";

function MainApp() {
  const { session, loading } = useSession();
  const [showLegal, setShowLegal] = useState(false);

  if (loading) return null;
  if (showLegal) return <LegalScreen onBack={() => setShowLegal(false)} />;

  return !session ? (
    <AuthScreen onOpenLegal={() => setShowLegal(true)} />
  ) : (
    <Dashboard userId={session.user.id} email={session.user.email ?? ""} />
  );
}

function App() {
  // Dil değiştiğinde tt() her yerde farklı metin döndürsün diye tüm
  // ağacı yeniden çizdiriyoruz (tt() React state'i değil, modül
  // seviyesinde bir değişken okuduğu için bu gerekli).
  const [, forceRerender] = useState(0);
  useEffect(() => subscribeLang(() => forceRerender((v) => v + 1)), []);

  if (!isSupabaseConfigured) return <ConfigMissingScreen />;

  return (
    <BrowserRouter>
      <ThemeSwitcher />
      <LanguageSwitcher />
      <Routes>
        <Route path="/events/:token" element={<EventRsvpScreen />} />
        <Route path="/book/:slug" element={<PublicBookingScreen />} />
        <Route path="/profile/:token" element={<ProfileViewScreen />} />
        <Route path="/legal" element={<LegalScreen onBack={() => window.history.back()} />} />
        <Route path="/pricing" element={<PricingScreen />} />
        <Route path="/businesses/:slug" element={<BusinessProfileScreen />} />
        <Route path="/*" element={<MainApp />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;